import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 兼容部分依赖包在浏览器环境下访问 process
if (typeof window !== 'undefined' && !window.process) {
  (window as any).process = {
    env: {},
    browser: true,
    version: '',
    versions: {},
    platform: 'browser',
    nextTick: (fn: Function) => setTimeout(fn, 0)
  };
}

// 注册Service Worker和初始化PWA更新管理器
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('SW registered: ', registration);
      
      // 初始化PWA更新管理器
      const { pwaUpdateManager } = await import('./utils/pwaUpdateManager');
      await pwaUpdateManager.init();
      console.log('PWA更新管理器初始化成功');
      
    } catch (registrationError) {
      console.log('SW registration failed: ', registrationError);
    }
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// reportWebVitals(console.log);